import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  public nmodal: number = 1;
  constructor() { }
}
